//User
export const AUTHENTICATE = "AUTHENTICATE"
export const INIT = "INIT"

//Common
export const SET_MESSAGEBAR = "MESSAGEBAR"
export const SET_URL = "SET_URL"
export const IS_LOADING = "IS_LOADING"
export const SET_BREADCRUMB = "SET_BREADCRUMB"
export const SET_COMMAND = "SET_COMMAND"
export const SET_MODAL = "SET_MODAL"

//Members
export const EDIT_MEMBER = "EDIT_MEMBER"
export const SET_MEMBERS = "SET_MEMBERS"
